import styled from "styled-components";

export const ModalFilterContent = styled.div`
  position: relative;
  z-index: 10000;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 8px;
  margin: 0 auto;
  padding: 0 10px 12px;
  max-height: 50vh;
  overflow: visible;

  .react-datepicker-popper {
    z-index: 10000 !important;
  }
`;

export const ModalFilterAction = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  button {
    margin: 8px 0 16px;
    min-height: 40px;
  }
`;
